import { Accordion, Box, Button, Container, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { React, useContext, useState } from "react";

import ButtonText from "@/components/Requerimiento/ButtonText";
import { Checkbox } from "@/components/ui/checkbox";
import { context } from "@/context/requirementsContext";

const ListHeader = ({ children }) => {
    return (
        <Text fontWeight="700" fontSize="xl" mb={2}>
            {children}
        </Text>
    );
};

const DatosGenerales = () => {
    const [rooms, setRooms] = useState("1");
    const [floors, setFloors] = useState("1");
    const [baths, setBaths] = useState("1");
    const [garage, setGarage] = useState("1");
    const [midBaths, setMidBaths] = useState("1");
    const [antiquity, setAntiquity] = useState("Nuevo");
    const [checkedItems, setCheckedItems] = useState([]);

    const { addDataProperty, updateStep } = useContext(context);

    const handleCheck = (e) => {
        let items_aux = [...checkedItems];
        if (checkedItems.find((items) => items === e)) {
            items_aux.pop(e);
        } else {
            items_aux.push(e);
        }
        setCheckedItems(items_aux);
    };

    const handleSubmit = (e) => {
        let data = [
            {
                name: "cuartos",
                value: rooms,
            },
            {
                name: "banios",
                value: baths,
            },
            {
                name: "medios_banos",
                value: midBaths,
            },
            {
                name: "pisos",
                value: floors,
            },
            {
                name: "estacionamientos",
                value: garage,
            },
            {
                name: "antiguedad",
                value: antiquity,
            },
            { caracteristicas_deseadas: checkedItems },
        ];

        addDataProperty(data);
        updateStep(2);
    };

    const numbers = ["1", "2", "3", "4", "5+"];

    const setValueButton = (type, value) => {
        switch (type) {
            case "rooms": {
                setRooms(value);
                break;
            }
            case "floors": {
                setFloors(value);
                break;
            }
            case "baths": {
                setBaths(value);
                break;
            }
            case "garage": {
                setGarage(value);
                break;
            }
            case "midBaths": {
                setMidBaths(value);
                break;
            }
            case "antiquity": {
                setAntiquity(value);
                break;
            }
        }
    };
    return (
        <>
            <Box
                bg="blackAlpha.50" //REF-71: Although previous value was blackAlpha.0, this new chakra v3 props, does not include it as well, instead we're using blackAlpha.50, as it is the most similar.
                color="blackAlpha.900"
                _dark={{ bg: "whiteAlpha.100", color: "gray.200" }} //User Story: REF-71. Implemented _dark native chakra prop in several files, where useColorModeValue was previously used.
                w="full"
                mx="auto"
                maxW="3x1"
                px={{ base: "2", md: "8" }}
                py={6}
                my={4}
            >
                <Container
                    maxW="6xl"
                    py={10}
                    pt={0}
                    _dark={{ borderColor: "gray.700" }} //User Story: REF-71
                    asChild
                >
                    <Stack>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit(e);
                            }}
                        >
                            <SimpleGrid
                                columns={{ base: 1, sm: 1, md: 2 }}
                                gap={{ md: 8, base: 6 }}
                            >
                                <Stack align="flex-start">
                                    <ListHeader>Cuartos:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 5, sm: 5, md: 5 }}
                                        gap={{ md: 8, base: 4 }}
                                    >
                                        {numbers.map((num, index) => (
                                            <ButtonText
                                                key={`room-button-${index}`}
                                                variant={rooms === num ? "solid" : "outline"}
                                                onclick={() => {
                                                    setValueButton("rooms", num);
                                                }}
                                                active={rooms === num ? true : false}
                                            >
                                                {num}
                                            </ButtonText>
                                        ))}
                                    </SimpleGrid>
                                </Stack>
                                <Stack align="flex-start">
                                    <ListHeader>Pisos:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 5, sm: 5, md: 5 }}
                                        gap={{ md: 8, base: 4 }}
                                    >
                                        {numbers.map((num) => (
                                            <ButtonText
                                                key={`floor-button-${num}`}
                                                variant={floors === num ? "solid" : "outline"}
                                                onclick={() => {
                                                    setValueButton("floors", num);
                                                }}
                                                active={floors === num ? true : false}
                                            >
                                                {num}
                                            </ButtonText>
                                        ))}
                                    </SimpleGrid>
                                </Stack>

                                <Stack align="flex-start">
                                    <ListHeader>Baños:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 5, sm: 5, md: 5 }}
                                        gap={{ md: 8, base: 4 }}
                                    >
                                        {numbers.map((num) => (
                                            <ButtonText
                                                key={`bath-button-${num}`}
                                                variant={baths === num ? "solid" : "outline"}
                                                onclick={() => {
                                                    setValueButton("baths", num);
                                                }}
                                                active={baths === num ? true : false}
                                            >
                                                {num}
                                            </ButtonText>
                                        ))}
                                    </SimpleGrid>
                                </Stack>
                                <Stack align="flex-start">
                                    <ListHeader>Estacionamientos:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 5, sm: 5, md: 5 }}
                                        gap={{ md: 8, base: 4 }}
                                    >
                                        {numbers.map((num) => (
                                            <ButtonText
                                                key={`garage-button-${num}`}
                                                variant={garage === num ? "solid" : "outline"}
                                                onclick={() => {
                                                    setValueButton("garage", num);
                                                }}
                                                active={garage === num ? true : false}
                                            >
                                                {num}
                                            </ButtonText>
                                        ))}
                                    </SimpleGrid>
                                </Stack>

                                <Stack align="flex-start">
                                    <ListHeader>Medios Baños:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 5, sm: 5, md: 5 }}
                                        gap={{ md: 8, base: 4 }}
                                    >
                                        {numbers.map((num) => (
                                            <ButtonText
                                                key={`mid-bath-button-${num}`}
                                                variant={midBaths === num ? "solid" : "outline"}
                                                onclick={() => {
                                                    setValueButton("midBaths", num);
                                                }}
                                                active={midBaths === num ? true : false}
                                            >
                                                {num}
                                            </ButtonText>
                                        ))}
                                    </SimpleGrid>
                                </Stack>
                                <Stack align="flex-start">
                                    <ListHeader>Antigüedad:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 3, sm: 3, md: 3 }}
                                        gap={{ md: 8, base: 2 }}
                                    >
                                        <ButtonText
                                            variant={antiquity === "Nuevo" ? "solid" : "outline"}
                                            onclick={() => {
                                                setValueButton("antiquity", "Nuevo");
                                            }}
                                            active={antiquity === "Nuevo" ? true : false}
                                        >
                                            Nuevo
                                        </ButtonText>
                                        <ButtonText
                                            variant={antiquity === "Usado" ? "solid" : "outline"}
                                            onclick={() => {
                                                setValueButton("antiquity", "Usado");
                                            }}
                                            active={antiquity === "Usado" ? true : false}
                                        >
                                            Usado
                                        </ButtonText>
                                        <ButtonText
                                            variant={
                                                antiquity === "Construccion" ? "solid" : "outline"
                                            }
                                            onclick={() => {
                                                setValueButton("antiquity", "Construccion");
                                            }}
                                            active={antiquity === "Construccion" ? true : false}
                                        >
                                            Construcción
                                        </ButtonText>
                                    </SimpleGrid>
                                </Stack>
                            </SimpleGrid>
                            <Stack direction="row" mt={7}>
                                <ListHeader>Características Deseadas:</ListHeader>
                            </Stack>
                            <SimpleGrid columns={{ base: 1, sm: 1, md: 1 }} gap={8}>
                                <SimpleGrid columns={{ base: 1, sm: 1, md: 2 }} gap={8}>
                                    <Stack align="flex-start">
                                        <Checkbox
                                            onChange={(e) => handleCheck(e.target.value)}
                                            size="lg"
                                            value="Acceso a discapacitados"
                                            colorPalette="yellow"
                                        >
                                            Acceso a Discapacitados
                                        </Checkbox>
                                        <Checkbox
                                            onChange={(e) => handleCheck(e.target.value)}
                                            size="lg"
                                            value="Alberca"
                                            colorPalette="yellow"
                                        >
                                            Alberca
                                        </Checkbox>
                                        <Checkbox
                                            onChange={(e) => handleCheck(e.target.value)}
                                            size="lg"
                                            value="Dentro de condominio"
                                            colorPalette="yellow"
                                        >
                                            Dentro de coto/condominio
                                        </Checkbox>
                                    </Stack>
                                    <Stack align="flex-start">
                                        <Checkbox
                                            onChange={(e) => handleCheck(e.target.value)}
                                            size="lg"
                                            value="Aire Acondicionado"
                                            colorPalette="yellow"
                                        >
                                            Aire Acondicionado
                                        </Checkbox>
                                        <Checkbox
                                            onChange={(e) => handleCheck(e.target.value)}
                                            size="lg"
                                            value="Cuarto de servicio"
                                            colorPalette="yellow"
                                        >
                                            Cuarto de servicios
                                        </Checkbox>
                                        <Checkbox
                                            onChange={(e) => handleCheck(e.target.value)}
                                            size="lg"
                                            value="Alarma"
                                            colorPalette="yellow"
                                        >
                                            Alarma
                                        </Checkbox>
                                    </Stack>
                                </SimpleGrid>
                            </SimpleGrid>

                            <Accordion.Root collapsible>
                                <Accordion.Item border="0px">
                                    <Accordion.ItemContent>
                                        <Accordion.ItemBody pb={4} pl={0} pt={0}>
                                            <SimpleGrid columns={{ base: 1, sm: 1, md: 2 }} gap={8}>
                                                <Stack align="flex-start">
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Andenes para Trailer"
                                                        colorPalette="yellow"
                                                    >
                                                        Andenes para Trailer
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Asador"
                                                        colorPalette="yellow"
                                                    >
                                                        Asador
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Bodega"
                                                        colorPalette="yellow"
                                                    >
                                                        Bodega
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Calentador de agua"
                                                        colorPalette="yellow"
                                                    >
                                                        Calentador de agua
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Centros comerciales cercanos"
                                                        colorPalette="yellow"
                                                    >
                                                        Centros comerciales cercanos
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Chimenea"
                                                        colorPalette="yellow"
                                                    >
                                                        Chimenea
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Cocina equipada"
                                                        colorPalette="yellow"
                                                    >
                                                        Cocina equipada
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Cuarto de TV"
                                                        colorPalette="yellow"
                                                    >
                                                        Cuarto de TV
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Escuelas Cercanas"
                                                        colorPalette="yellow"
                                                    >
                                                        Escuelas Cercanas
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Estacionamiento techado"
                                                        colorPalette="yellow"
                                                    >
                                                        Estacionamiento techado
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Facilidades para adultos mayores"
                                                        colorPalette="yellow"
                                                    >
                                                        Facilidades para adultos mayores
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Frente a parque"
                                                        colorPalette="yellow"
                                                    >
                                                        Frente a parque
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Gimnasio"
                                                        colorPalette="yellow"
                                                    >
                                                        Gimnasio
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Jardin"
                                                        colorPalette="yellow"
                                                    >
                                                        Jardin
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Planta eléctrica"
                                                        colorPalette="yellow"
                                                    >
                                                        Planta eléctrica
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Roof garden"
                                                        colorPalette="yellow"
                                                    >
                                                        Roof garden
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Salón de usos múltiples"
                                                        colorPalette="yellow"
                                                    >
                                                        Salón de usos múltiples
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Se permite fumar"
                                                        colorPalette="yellow"
                                                    >
                                                        Se permite fumar
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Seguridad privada"
                                                        colorPalette="yellow"
                                                    >
                                                        Seguridad privada
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Sistema de ventilación"
                                                        colorPalette="yellow"
                                                    >
                                                        Sistema de ventilación
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="terraza"
                                                        colorPalette="yellow"
                                                    >
                                                        Terraza
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Zona industrial"
                                                        colorPalette="yellow"
                                                    >
                                                        Zona industrial
                                                    </Checkbox>
                                                </Stack>
                                                <Stack align="flex-start" pl={{ md: 2, base: 0 }}>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Amueblado"
                                                        colorPalette="yellow"
                                                    >
                                                        Amueblado
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Balcones"
                                                        colorPalette="yellow"
                                                    >
                                                        Balcones
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Bodega de servicio"
                                                        colorPalette="yellow"
                                                    >
                                                        Bodega de servicio
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Cancha de tenis"
                                                        colorPalette="yellow"
                                                    >
                                                        Cancha de tenis
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Caseta de guardia"
                                                        colorPalette="yellow"
                                                    >
                                                        Caseta de guardia
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Circuito cerrado"
                                                        colorPalette="yellow"
                                                    >
                                                        Circuito cerrado
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Conmutador"
                                                        colorPalette="yellow"
                                                    >
                                                        Conmutador
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Elevador"
                                                        colorPalette="yellow"
                                                    >
                                                        Elevador
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Estacionamiento de visitas"
                                                        colorPalette="yellow"
                                                    >
                                                        Estacionamiento de visitas
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Estudio"
                                                        colorPalette="yellow"
                                                    >
                                                        Estudio
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Facilidades para discapacitados"
                                                        colorPalette="yellow"
                                                    >
                                                        Facilidades para discapacitados
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Generador eléctrico"
                                                        colorPalette="yellow"
                                                    >
                                                        Generador eléctrico
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Jacuzzi"
                                                        colorPalette="yellow"
                                                    >
                                                        Jacuzzi
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Linea telefónica"
                                                        colorPalette="yellow"
                                                    >
                                                        Linea telefónica
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Parrilla"
                                                        colorPalette="yellow"
                                                    >
                                                        Parrilla
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Salón de fiestas"
                                                        colorPalette="yellow"
                                                    >
                                                        Salón de fiestas
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Se aceptan mascotas"
                                                        colorPalette="yellow"
                                                    >
                                                        Se aceptan mascotas
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Seguridad contra incendios"
                                                        colorPalette="yellow"
                                                    >
                                                        Seguridad contra incendios
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Servicios básicos"
                                                        colorPalette="yellow"
                                                    >
                                                        Servicios básicos
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Tanque de gas estacionario"
                                                        colorPalette="yellow"
                                                    >
                                                        Tanque de gas estacionario
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Tinaco"
                                                        colorPalette="yellow"
                                                    >
                                                        Tinaco
                                                    </Checkbox>
                                                    <Checkbox
                                                        onChange={(e) =>
                                                            handleCheck(e.target.value)
                                                        }
                                                        size="lg"
                                                        value="Área de juegos infantiles"
                                                        colorPalette="yellow"
                                                    >
                                                        Área de juegos infantiles
                                                    </Checkbox>
                                                </Stack>
                                            </SimpleGrid>
                                        </Accordion.ItemBody>
                                    </Accordion.ItemContent>
                                    <h2>
                                        <Accordion.ItemTrigger
                                            w="170px"
                                            _hover={{ textDecoration: "underline" }}
                                            cursor="pointer"
                                        >
                                            <Box flex="1" textAlign="left" size="sm" py={4}>
                                                Mostrar todos
                                            </Box>
                                            <Accordion.ItemIndicator />
                                        </Accordion.ItemTrigger>
                                    </h2>
                                </Accordion.Item>
                            </Accordion.Root>

                            <SimpleGrid columns={{ base: 1, sm: 1, md: 2 }} gap={8} pt={10}>
                                <Stack align="center">
                                    <Button
                                        rounded="full"
                                        colorPalette="brand"
                                        bg="brand.500"
                                        color="black"
                                        border="0"
                                        px="16"
                                        my="4"
                                        _hover={{ bg: "brand.600" }}
                                        onClick={() => updateStep(0)}
                                    >
                                        Atrás
                                    </Button>
                                </Stack>
                                <Stack align="center">
                                    <Button
                                        rounded="full"
                                        colorPalette="brand"
                                        bg="brand.500"
                                        color="black"
                                        border="0"
                                        px="16"
                                        my="4"
                                        _hover={{ bg: "brand.600" }}
                                        type="submit"
                                    >
                                        Siguiente
                                    </Button>
                                </Stack>
                            </SimpleGrid>
                        </form>
                    </Stack>
                </Container>
            </Box>
        </>
    );
};
export default DatosGenerales;
